//@ts-check
import React from 'react';
import Loader from './Loader';
import Alert from '../Alert';

import { Utils, Communication } from 'ecrion-components';

const DEFAULT_STATE = {
  loading: true,
  error: '',
  job: { Workspace: '', Id: '' },
  communicationId: '',
};

/**
 * @param {import('./types').DemandCommunicationProps} param
 */
const Demand = ({ communication, parameters, accessToken }) => {
  const [state, setState] = React.useState(DEFAULT_STATE);
  const { loading, error, job, communicationId } = state;
  const setJobState = (error, job, communicationId) =>
    setState({ loading: false, error, job, communicationId });

  const jobParameters = parameters.map((p) => ({
    Name: p.name,
    Value: p.value,
  }));

  React.useEffect(() => {
    const communicationRunOptions = {
      method: 'POST',
      url: '/backend/communicationrun',
      contentType: 'json',
      data: { Name: communication, JobParameters: jobParameters, Sync: true },
    };

    const communicationsOptions = {
      url: `/backend/communications?name=${communication}`,
    };

    if (accessToken) {
      communicationRunOptions.headers = {
        Authorization: `Basic ${btoa(accessToken)}`,
      };
      communicationsOptions.headers = {
        Authorization: `Basic ${btoa(accessToken)}`,
      };
    }

    Utils.request(communicationRunOptions).then(
      (job) => {
        Utils.request(communicationsOptions).then(
          (comm) => {
            setJobState('', job, comm.Id);
          },
          (error) => {
            setJobState(Utils.getPrettyError(error), null);
          }
        );
      },
      (error) => {
        setJobState(Utils.getPrettyError(error), null);
      }
    );
  }, []);

  if (loading) return <Loader>Generating documents....</Loader>;

  if (error) return <Alert>{error}</Alert>;

  if (job)
    return (
      <Communication.Run.JobDetails
        token={accessToken}
        jobId={job.Id}
        workspace={job.Workspace}
        projectId={communicationId}
        variant="portal"
      />
    );
};

export default Demand;
